import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { NavbarComponent } from '../../components/Navbar/Navbar.component';
// import Header from "../../components/Header";
import { SidebarComponent } from '../../components/Sidebar/Sidebar.component';
// import FreshdeskWebChat from '../../components/FreshdeskWebChat';
import { SetupGuideProvider } from '../../contexts/SetupGuide.context';
import { NavbarSlotProvider } from '../../contexts/NavbarSlot.context';
import { SupportWidgetProvider } from '../../contexts/SupportWidget.context';
import {
  SubscriptionBannerProvider,
  useIsSubscriptionBannerVisible,
} from '../../contexts/SubscriptionBanner.context';
import { SetupGuide } from '../../views/DashboardOverview/components/SetupGuide.component';
import AppLogo from '@/assets/img/brand/logo-transparent-blue.png';
import { useDefaultDashboardRoute } from '@/hooks/usePermission';
import '@/assets/css/custom.css';

const MainContent = ({ location, children }) => {
  const defaultDashboardRoute = useDefaultDashboardRoute();
  // const hasNavbar = location && location.pathname.includes('dashboard') ? true : false
  const hasNavbar = true;
  const bannerVisible = useIsSubscriptionBannerVisible();
  return (
    <SetupGuideProvider>
      <NavbarSlotProvider>
        {/* Freshdesk widget disabled — currently broken (button renders but chat doesn't open) */}
        {/* {!supportWidgetHidden && <FreshdeskWebChat />} */}
        <SidebarComponent
          location={location}
          logo={{
            innerLink: defaultDashboardRoute,
            imgSrc: AppLogo,
            imgAlt: '...',
          }}
        />
        <div
          className="main-content"
          id="main_portal_target"
          style={{
            transition: 'margin-left 0.3s ease',
            backgroundColor: '#f9fafb',
          }}
        >
          {/* Padding lives here, not on the outer .main-content box, so the
              banner's push-down never grows this element past its parent's
              fixed 100vh (border-box sizing) — that mismatch is what let
              .main-content's overflow:hidden permanently clip the bottom of
              this element's own scrollable content. */}
          <div
            className="main-content-child with-scroll"
            id="app-scroll-container"
            style={{
              paddingTop: bannerVisible ? '60px' : '0px',
              transition: 'padding-top 0.3s ease',
            }}
          >
            {hasNavbar && <NavbarComponent location={location} />}

            <div className="content">{children} </div>
          </div>
        </div>
        <SetupGuide />
      </NavbarSlotProvider>
    </SetupGuideProvider>
  );
};

MainContent.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

const Main = (props) => (
  <SupportWidgetProvider>
    <SubscriptionBannerProvider>
      <MainContent {...props} />
    </SubscriptionBannerProvider>
  </SupportWidgetProvider>
);

Main.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(Main);
